import { h } from "preact";

export function LabelMetadataEditorHelp() {
    return <div class="accordion" style="margin-top: 10px;">
        <div>
            <input type="radio" name="accordion" />
            <input type="radio" name="accordion" />
            <div class="header">Pomoc</div>
            <div class="content" style="flex-direction: column">
                <div style="margin-top: 10px;">
                    Pola dotyczące drukarki:
                    <table>
                        <thead>
                            <th>Pole</th>
                            <th>Wartość</th>
                            <th>Opis</th>
                        </thead>
                        <tbody>
                            <tr>
                                <td><code>printer</code></td>
                                <td>Brother P900W</td>
                                <td>pozwala określić na jaką drukarkę została przygotowana naklejka</td>
                            </tr>
                            <tr>
                                <td><code>high-quality</code></td>
                                <td>true / false</td>
                                <td>określa czy naklejka ma być drukowana w wysokiej jakości</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style="margin-top: 10px;">
                    Pola z informacjami o taśmie:
                    <table>
                        <thead>
                            <th>Pole</th>
                            <th>Wartość</th>
                            <th>Opis</th>
                        </thead>
                        <tbody>
                            <tr>
                                <td><code>tape-width</code></td>
                                <td>[x] mm</td>
                                <td>pozwala określić na jaką szerokość taśmy została przygotowana naklejka naklejka</td>
                            </tr>
                            <tr>
                                <td><code>tape-type</code></td>
                                <td>...</td>
                                <td>określa dla jakiego rodzaju taśmy została przygotowana naklejka</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style="margin-top: 10px;">
                    <strong>Pola do wpisywania przez użytkownika</strong>
                    <div>Wszystkie pola posiadające nazwę zaczynającą się od <code>field-</code> oznaczają pola, które muszą zostać uzupełnione przez użytkownika. W wartości takiego pola wpisywany jest jego typ. Dostępne typy dla pól wypisane są w tabeli poniżej.</div>
                    <table>
                        <thead>
                            <th>Typ</th>
                            <th>Opis</th>
                            <th>Domyślny opis dla użytkownika</th>
                        </thead>
                        <tbody>
                            <tr>
                                <td><code>text</code></td>
                                <td>użytkownik może wpisać dowolny tekst</td>
                                <td>Wartość tekstowa</td>
                            </tr>
                            <tr>
                                <td><code>date</code></td>
                                <td>użytkownik może podać dowolną date bez możliwości wpisania czasu</td>
                                <td>Data</td>
                            </tr>
                            <tr>
                                <td><code>serial-8-base32</code></td>
                                <td>użytkownik może wpisać 8 znakowy numer seryjny zgodny z formatem base32 używanym dla Stella BIO</td>
                                <td>Numer seryjny</td>
                            </tr>
                            <tr>
                                <td><code>serial-6-base16</code></td>
                                <td>użytkownik może wpisać 6 znakowy numer seryjny zgodny z formatem base16 używanym dla Luna EMG</td>
                                <td>Numer seryjny</td>
                            </tr>
                        </tbody>
                    </table>
                    <div>Aby dodać czytelny opis dla takiego pola, któy będzie wyświetlany użytkownikowi, należy stworzyć pole o takej samej nazwie w środku, którego nazwa zaczyna się prefiksem <code>description-field-</code>.</div>
                </div>
            </div>
        </div>
    </div>;
}
